import { render, staticRenderFns } from "./panel_trans.vue?vue&type=template&id=4a7ea0c4&scoped=true&"
import script from "./panel_trans.vue?vue&type=script&lang=js&"
export * from "./panel_trans.vue?vue&type=script&lang=js&"
import style0 from "./panel_trans.vue?vue&type=style&index=0&id=4a7ea0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7ea0c4",
  null
  
)

export default component.exports